module.exports = function() {
  return new Worker("/" + "less-transpiler.f14cef75.worker.js");
};